// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"d58c7e0f","582":"c0673c5d"}[chunkId] + ".chunk.js";
};